import React from 'react';
import { MiniArrowIcon } from '@components/icons/mini-arrow-icon';
import { Header } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/header';
import type { MobileHeaderProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/mobile-header/types';
import cn from 'classnames';

import { Container, Content } from './styles';

export const MobileHeader: React.FC<MobileHeaderProps> = ({
    onBack,
    title,
    className,
    isFixed,
}) => (
    <Container>
        <Header />
        <Content className={cn('header-mobile-container', { 'fixed-header': isFixed }, className)}>
            <MiniArrowIcon className='mobile-header-back-icon' onClick={onBack} />
            <span className='inner-title' dangerouslySetInnerHTML={{ __html: title }} />
        </Content>
    </Container>
);
